"use client";
import { useCompositeGroup } from "../composite/composite-group.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/menu/menu-group.tsx
const TagName = "div";
/**
* Returns props to create a `MenuGroup` component.
* @see https://ariakit.com/components/menu
* @example
* ```jsx
* const store = useMenuStore();
* const props = useMenuGroup({ store });
* <MenuButton store={store}>Recent Items</MenuButton>
* <Menu store={store}>
*   <Role {...props}>
*     <MenuGroupLabel>Applications</MenuGroupLabel>
*     <MenuItem>Google Chrome.app</MenuItem>
*     <MenuItem>Safari.app</MenuItem>
*   </Role>
* </Menu>
* ```
*/
const useMenuGroup = createHook(function useMenuGroup(props) {
	props = useCompositeGroup(props);
	return props;
});
/**
* Renders a group for [`MenuItem`](https://ariakit.com/reference/menu-item)
* elements. Optionally, a
* [`MenuGroupLabel`](https://ariakit.com/reference/menu-group-label) can be
* rendered as a child to provide a label for the group.
* @see https://ariakit.com/components/menu
* @example
* ```jsx {4-8}
* <MenuProvider>
*   <MenuButton>Recent Items</MenuButton>
*   <Menu>
*     <MenuGroup>
*       <MenuGroupLabel>Applications</MenuGroupLabel>
*       <MenuItem>Google Chrome.app</MenuItem>
*       <MenuItem>Safari.app</MenuItem>
*     </MenuGroup>
*   </Menu>
* </MenuProvider>
* ```
*/
const MenuGroup = forwardRef(function MenuGroup(props) {
	return createElement(TagName, useMenuGroup(props));
});
//#endregion
export { MenuGroup, useMenuGroup };

//# sourceMappingURL=menu-group.js.map